import DataTable from '../../components/DataTable';

function DealsTable({ deals, stages, onOpenDeal }) {
  const stageMap = new Map(stages.map((stage) => [stage.id, stage]));

  const columns = [
    { key: 'title', label: 'Сделка' },
    {
      key: 'crm_company_name',
      label: 'Компания',
      render: (deal) => deal.crm_company_name || '-'
    },
    {
      key: 'contacts',
      label: 'Контакты',
      render: (deal) => deal.contact_names?.length ? deal.contact_names.join(', ') : deal.primary_contact_name || '-'
    },
    {
      key: 'stage',
      label: 'Стадия',
      render: (deal) => stageMap.get(deal.stage_id)?.name || '-'
    },
    {
      key: 'amount',
      label: 'Сумма',
      render: (deal) => deal.amount ? `${deal.amount} ${deal.currency}` : '-'
    },
    {
      key: 'retainer',
      label: 'Абонентское',
      render: (deal) => deal.is_retainer ? 'Да' : '-'
    }
  ];

  return (
    <DataTable
      className="crm__table"
      headerClassName="crm__row crm__row--head"
      rowClassName="crm__row crm__row--clickable"
      columns={columns}
      rows={deals}
      getRowKey={(deal) => deal.id}
      onRowClick={(deal) => onOpenDeal(deal)}
    />
  );
}

export default DealsTable;
